import { FormattedMessage as OriginalFormattedMessage } from 'react-intl';
import { defaultValues } from './i18nFormatters';

type FormattedMessageProps = React.ComponentProps<
    typeof OriginalFormattedMessage
>;

export const FormattedMessage = (props: FormattedMessageProps) => {
    const mergedValues = {
        ...defaultValues,
        ...props.values,
    };

    return <OriginalFormattedMessage {...props} values={mergedValues} />;
};
